import {GetBusinessInfoLogic, GetGeoLocationLogic, GetRatingShopLogic} from "../Application/GetBusinessInfo.logic";
import {
  GetBusinessListLogic,
  GetBusinessListByCategoryLogic,
  GetBusinessListByNameLogic,
  GetListCategoriesLogic,
  GetListOfferProductsLogic,
  GetBusinessListByMultipleCategoriesLogic,
} from "../Application/GetBusinessList.logic";
import {GetListReviewsLogic, GetListReviewsByDateLogic} from "../Application/GetBusinessComments.logic";
import {GetListCommissionsLogic,  GetCommissionsByShopLogic, GetOrdersByShopLogic,GetMethodPayLogic, getDataBankShopLogic} from "../Application/GetCommissions.logic";

export async function GetBusinessInfo(id) {
  try {
    const data = await GetBusinessInfoLogic(id);
    return {valid: true, info: data};
  }catch(error){
    return {valid: false, info: error};
  }
}

export async function GetBusinessList(zone) {
  return await GetBusinessListLogic(zone);
}

export async function GetBusinessListByCategory(zone, category) {
  return await GetBusinessListByCategoryLogic(zone, category);
}

export async function GetBusinessListByMultipleCategories(zone, categories) {
  return await GetBusinessListByMultipleCategoriesLogic(zone, categories);
}

export async function GetBusinessListByName(zone, name) {
  return await GetBusinessListByNameLogic(zone, name);
}

export async function GetListCategories(){
  return await GetListCategoriesLogic();
}

export async function GetListOfferProducts(id){
  return GetListOfferProductsLogic(id);
}

export async function GetGeoLocationShop(id){
  return GetGeoLocationLogic(id);
}

export async function GetRatingShop(id){
  return GetRatingShopLogic(id);
}

export async function GetListReviews(id){
  return GetListReviewsLogic(id);
}

export async function GetListReviewsByDate(id, date){
  return GetListReviewsByDateLogic(id, date);
}

export async function GetListCommissions(zone) {
  return GetListCommissionsLogic(zone);
}

export async function GetCommissionsByShop(id){
  return GetCommissionsByShopLogic(id);
}

export async function GetOrdersByShop(id){
  return GetOrdersByShopLogic(id);
}
export async function getMethodPay(id){
return GetMethodPayLogic(id);
}

export async function getDataBankShop(id){
  return getDataBankShopLogic(id);
}